// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"e6a152d6","165":"0eff2b35","408":"c4cffb92","960":"177fe276"}[chunkId] + ".chunk.js";
};